import { Injectable } from '@angular/core';

import { PERIOD_CLOSE_ROUTES_FEATURE_FLAGS } from '@shared/constants/feature-flags-guards/period-close-routes-feature-flags.const';
import { ROUTING_PATH } from '@shared/constants/routingPath';
import { BasicRedirectToNextTabGuard } from '@shared/guards/basic-redirect-to-next-tab.guard';
import { Flags } from '@shared/services/launch-darkly.service';

@Injectable({
  providedIn: 'root',
})
export class QuarterCloseChecklistGuard extends BasicRedirectToNextTabGuard {
  protected defaultNavigateUrl = `/${ROUTING_PATH.BUDGET.INDEX}/${ROUTING_PATH.BUDGET.BUDGET.INDEX}`;
  protected featureFlag = 'checklist_tab' as keyof Flags;
  protected prefix = `/${ROUTING_PATH.CLOSING.INDEX}`;
  protected routerPathsAndFeatureFlags = PERIOD_CLOSE_ROUTES_FEATURE_FLAGS;
}
